<template lang="pug">
v-container(
  fluid
  py-0
  @click="$router.push({ name: 'opportunityTasks', params: { id: task.opportunity_id } })"
  class="tw-cursor-pointer"
)
  v-row(no-gutters)
    v-col(class=" tw--my-2")
      v-icon(size="44" color=" purple darken-3" class="tw--mr-4 tw--ml-4") mdi-circle-small
      span(class=" tw-text-xs tw-font-semibold tw-text-purple-darken-3") {{ this.$moment(task.due_date).format('MMM Do') }}
  v-row(no-gutters)
    v-col(class="tw--mt-2")
      span(class=" tw-text-sm  tw-text-blueGray-darken-5 tw-leading-3") {{ task.name }}
</template>
<script>
export default {
  props: ['task'],
};
</script>
